import { AllocationRule } from 'further-types/lp/allocations';
import { z } from 'zod';
import { isMongoId } from '../../helpers';

export const CreateAllocation = z.object({
  commitmentId: z.string().refine(isMongoId()),
  allocationAmountTcy: z.number(),
  allocationPercentage: z.number(),
  excludeFromAllocation: z.boolean(),
});

export const GenerateAllocations = z.object({
  vehicleId: z.string().refine(isMongoId()),
  allocationRule: z.nativeEnum(AllocationRule),
  amountTcy: z.number(),
  excludedCommitmentIds: z.array(z.string()),
  commitmentIdsToConsider: z.array(z.string().refine(isMongoId())).optional(),
  currentActionIds: z.array(z.string().refine(isMongoId())).optional(),
  sourceAllocationActionId: z
    .string()
    .optional()
    .refine(isMongoId({ optional: true })),
  shouldIncludeCommitmentsBeingEqualised: z.boolean().optional(),
});

export const GetAllocations = z.object({
  currentActionId: z
    .string()
    .optional()
    .refine(isMongoId({ optional: true })),
  allocationRule: z.nativeEnum(AllocationRule),
  allocatedAmountTcy: z.number(),
  excludedCommitmentIds: z.array(z.string()),
  allocationsSourceActionId: z
    .string()
    .optional()
    .refine(isMongoId({ optional: true })),
  reconcilableTransactions: z
    .array(
      z.object({
        transactionId: z.string().refine(isMongoId()),
        transactionAmountLcy: z.number().optional(),
        transactionAmountTcy: z.number(),
      }),
    )
    .optional(),
});
